import { useLang } from "@/context/LanguageContext";
import { Reveal, Overline } from "@/components/site/Reveal";

const Stars = () => (
  <div className="flex gap-1" aria-label="5 su 5">
    {[0, 1, 2, 3, 4].map((i) => (
      <svg key={i} viewBox="0 0 24 24" className="h-4 w-4 fill-gold" aria-hidden="true">
        <path d="M12 2.5l2.9 5.9 6.5.9-4.7 4.6 1.1 6.5L12 18.9 6.2 20.9l1.1-6.5L2.6 9.3l6.5-.9L12 2.5z" />
      </svg>
    ))}
  </div>
);

export const Reviews = () => {
  const { t } = useLang();
  const r = t.reviews;

  return (
    <section id="reviews" className="relative bg-canvas" data-testid="reviews">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 py-28 md:py-40">
        <Reveal className="max-w-3xl">
          <Overline>{r.overline}</Overline>
          <h2 className="mt-5 font-serif font-light text-navy text-5xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tight">
            {r.title}
          </h2>
        </Reveal>

        <div className="mt-16 grid gap-6 sm:grid-cols-2">
          {r.list.map((rev, i) => (
            <Reveal key={rev.name} delay={i * 0.08}>
              <figure
                className="flex h-full flex-col rounded-2xl border border-gold/40 bg-white/60 p-8 shadow-[0_20px_50px_-24px_rgba(10,25,47,0.35)] transition-colors hover:border-gold"
                data-testid={`review-card-${i}`}
              >
                <Stars />
                <blockquote className="mt-5 flex-1 font-serif text-xl md:text-2xl font-light leading-relaxed text-navy/85">
                  “{rev.text}”
                </blockquote>
                <figcaption className="mt-6 border-t border-navy/10 pt-4">
                  <span className="block text-sm font-medium tracking-wide text-navy">{rev.name}</span>
                  <span className="block text-xs uppercase tracking-[0.2em] text-golddeep">{rev.origin}</span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
